import type { RouteRecordRaw } from "vue-router";

export const converterRoutes: RouteRecordRaw[] = [
  // AI Converters
  {
    path: "/ai/converters",
    name: "ai_converter-index",
    component: () => import("./converters/ConverterPage.vue"),
    meta: {
      title: "tools_meta.ai_converters_prefix",
    },
  },
  {
    path: "/ai/converters/history",
    name: "ai_converter-history",
    component: () => import("./converters/history.vue"),
    meta: {
      title: "tools_meta.ai_converters_prefix",
    },
  },
  {
    path: "/ai/converters/history/:id",
    name: "ai_converter-show",
    component: () =>
      import("./converters/history/ConverterHistoryDetailPage.vue"),
    meta: {
      title: "tools_meta.ai_converters_prefix",
    },
  },
  {
    path: "/ai/converters/info",
    name: "ai_converter-info",
    component: () => import("./converters/info.vue"),
    meta: {
      title: "tools_meta.ai_converters_prefix",
    },
  },
];
